import { Pressable, StyleSheet, View } from 'react-native';
import { ChevronLeft, ChevronRight, Pause, Play } from 'lucide-react-native';
import { SPACING } from '../../../theme';
import { CURSOR_POINTER } from '../../../utils/webStyles';

/** Prev / autoplay / next, shared by both presentation surfaces. Only the
 *  icon color differs: dark ink in the panel, white over the fullscreen
 *  ground. */
export function SlideshowControls({
  autoplay,
  onPrev,
  onNext,
  onToggleAutoplay,
  iconColor,
  style,
}: {
  autoplay: boolean;
  onPrev: () => void;
  onNext: () => void;
  onToggleAutoplay: () => void;
  iconColor: string;
  style?: object;
}) {
  return (
    <View style={[styles.bar, style]}>
      <Pressable
        onPress={onPrev}
        testID="map-slideshow-prev"
        accessibilityRole="button"
        accessibilityLabel="Previous observation"
        style={[styles.button, CURSOR_POINTER]}>
        <ChevronLeft size={22} color={iconColor} />
      </Pressable>
      <Pressable
        onPress={onToggleAutoplay}
        testID="map-slideshow-autoplay"
        accessibilityRole="button"
        aria-pressed={autoplay}
        accessibilityLabel={autoplay ? 'Pause autoplay' : 'Play autoplay'}
        style={[styles.button, CURSOR_POINTER]}>
        {autoplay ? <Pause size={20} color={iconColor} /> : <Play size={20} color={iconColor} />}
      </Pressable>
      <Pressable
        onPress={onNext}
        testID="map-slideshow-next"
        accessibilityRole="button"
        accessibilityLabel="Next observation"
        style={[styles.button, CURSOR_POINTER]}>
        <ChevronRight size={22} color={iconColor} />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: SPACING.lg,
  },
  button: {
    padding: SPACING.sm,
  },
});
